import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';

@Injectable({
    providedIn: 'root'
})
export class PropertyService {
    get propertyUrl(): string{
        return `${this.dataCollectorService.baseurl()}/property`;
    }
    get customerUrl(): string{
        return `${this.dataCollectorService.baseurl()}/customers/`;
    }
    get organizationUrl(): string{
        return `${this.dataCollectorService.baseurl()}/organization/`;
    }
    get projectUrl(): string{
        return `${this.dataCollectorService.baseurl()}/projects`;
    } 
    get propertyAPIUrls(): any{
        return {
            dataUrl:  `${ this.propertyUrl}/filter`,
            columnUrl:  `${ this.propertyUrl}/meta`,
            filterUrl:  `${ this.propertyUrl}/meta/filter`,
            bulkActionUrl:  `${ this.propertyUrl}/bulk_action`,
            invoiceUrl: `${this.dataCollectorService.baseurl()}/invoice`,
            estimateUrl: `${this.dataCollectorService.baseurl()}/estimate`,
            propertyUrl: `${this.dataCollectorService.baseurl()}/property`,
            serviceContractUrl: `${this.dataCollectorService.baseurl()}/service_contract`,
            assetsUrl: `${this.dataCollectorService.baseurl()}/assets`,
            noteAttachmentUrl: `${this.dataCollectorService.baseurl()}/note_attachment`,
            requestUrl: `${this.dataCollectorService.baseurl()}/request`
        };
    }
    propertyDetailsLoaded: Subject<boolean> = new Subject<boolean>();
    currentPropertyDetails = new BehaviorSubject<any>(null);
    selectedOrganizationCustomerPickerFilterValue = new BehaviorSubject<any>(null);

    constructor(private dataCollectorService: DataCollectorService) {
        this.propertyDetailsLoaded.next(false);
    }

    activationURl(propertyId: string): string {
        return `${ this.propertyUrl}/${propertyId}/activate`;
    }

    deleteURL(propertyId: string): string {
        return `${ this.propertyUrl}/${propertyId}`;
    }

    getPropertyDetails(propertyId: string): string {
        return `${ this.propertyUrl}/${propertyId}`;
    }

    getPropertyNotes(propertyId: string): string {
        return `${this.dataCollectorService.baseurl()}/notes`;
    }

    getProjectUrl(): string {
        return `${ this.projectUrl}`;
    }
}
